import React from 'react'

const BulkActionsPage = () => {
  return (
    <div>BulkActionsPage</div>
  )
}

export default BulkActionsPage